import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import NumericKeypad from './NumericKeypad';
import { BASE_URL, ENDPOINTS } from '../config/api';
import './Login.css';

const Login = () => {
    const navigate = useNavigate();
    const [badgeNumber, setBadgeNumber] = useState('');
    const [apiError, setApiError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (authService.isAuthenticated()) {
            navigate('/home');
        }
    }, [navigate]);

    const handleKeyPress = (number) => {
        if (badgeNumber.length < 5) {
            setBadgeNumber(prev => prev + number);
        }
    };

    const handleDelete = () => {
        setBadgeNumber(prev => prev.slice(0, -1));
    };

    const handleClear = () => {
        setBadgeNumber('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (badgeNumber.length !== 5) {
            setApiError('Le numéro de badge doit contenir 5 chiffres');
            return;
        }

        setIsLoading(true);
        setApiError('');
        setSuccessMessage('');

        try {
            const response = await fetch(`${BASE_URL}${ENDPOINTS.LOGIN}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    badgeNumber: badgeNumber
                }),
            });

            if (response.ok) {
                const token = response.headers.get('Authorization');
                if (token) {
                    authService.setToken(token);
                    authService.setBadgeNumber(badgeNumber);
                    setSuccessMessage('Connexion réussie !');
                    setTimeout(() => {
                        navigate('/home');
                    }, 1500);
                } else {
                    setApiError("Erreur d'authentification - token manquant");
                }
            } else if (response.status === 404) {
                setApiError('Badge non reconnu');
            } else if (response.status === 500) {
                setApiError('Erreur serveur - Veuillez réessayer plus tard');
            } else if (response.status === 400) {
                setApiError('Données invalides - Vérifiez vos informations');
            } else {
                setApiError('Erreur de connexion');
            }
        } catch (error) {
            setApiError('Erreur de connexion au serveur');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <h1>SPIN-LITE</h1>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="badgeNumber">Numéro de badge</label>
                        <div className="badge-display">
                            {badgeNumber || '--------'}
                        </div>
                        <NumericKeypad
                            onKeyPress={handleKeyPress}
                            onDelete={handleDelete}
                            onClear={handleClear}
                        />
                    </div>

                    {apiError && <div className="error-message">{apiError}</div>}
                    {successMessage && <div className="success-message">{successMessage}</div>}

                    <button type="submit" className="login-button" disabled={isLoading}>
                        {isLoading ? 'Connexion...' : 'Se connecter'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login; 